import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Card } from 'antd';

import { avisIntroduccioModificarCoordenades, avisIntroduccioModificarAltitud } from '../../actions/avis';

import { selectorMunicipisAmbCoordenadesIComarca } from '../../selectors/selector_municipis';

import LocalitzacioIntroduccioCamps from '../commons/localitzacioIntroduccioCamps';
import LocalitzacioIntroduccioMapa from '../commons/localitzacioIntroduccioMapa';

class AvisIntroduccioSeccioDadesLocalitzacio extends Component {

    render() {
        const { municipis, coordenades, altitud, errorsCoordenades } = this.props;
        const { avisIntroduccioModificarCoordenades, avisIntroduccioModificarAltitud } = this.props;

        return (
            <Card title='Localització'>
                <LocalitzacioIntroduccioCamps
                    municipis={municipis}
                    coordenades={coordenades}
                    altitud={altitud}
                    errorsCoordenades={errorsCoordenades}
                    classeCss='localitzacio-introduccio-camps avis-introduccio-seccio-dades-localitzacio-camps'
                    onChangeCoordenades={avisIntroduccioModificarCoordenades}
                    onChangeAltitud={avisIntroduccioModificarAltitud}
                />

                <LocalitzacioIntroduccioMapa
                    coordenades={coordenades}
                    classeCss='localitzacio-introduccio-mapa avis-introduccio-seccio-dades-localitzacio-mapa'
                    onChangeCoordenades={avisIntroduccioModificarCoordenades}
                    habilitarCoordenadesForaCatalunya={false}
                />
            </Card>
        );
    }
}

AvisIntroduccioSeccioDadesLocalitzacio.propTypes = {
    municipis: PropTypes.object,
    coordenades: PropTypes.object,
    altitud: PropTypes.number,
    errorsCoordenades: PropTypes.object,
    avisIntroduccioModificarCoordenades: PropTypes.func,
    avisIntroduccioModificarAltitud: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        municipis: selectorMunicipisAmbCoordenadesIComarca(state),
        coordenades: state.avis.formulari.dades.coordenades,
        altitud: state.avis.formulari.dades.altitud,
        errorsCoordenades: state.avis.formulari.errors.coordenades
    };
};

export default connect(mapStateToProps, { avisIntroduccioModificarCoordenades, avisIntroduccioModificarAltitud })(AvisIntroduccioSeccioDadesLocalitzacio);



// WEBPACK FOOTER //
// ./src/components/avis/avisIntroduccioSeccioDadesLocalitzacio.js